const camelcaseToKebabcase = str => str.replace(/([A-Z])/g, g => `-${g[0].toLowerCase()}`);

export default camelcaseToKebabcase;
